import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { getImageStyle } from 'site-modules/editorial/components/top-rated/winner-tiles-nav/get-image-style';
import { CmsEntities } from 'client/data/models/cms';
import { ElectricBolt } from 'client/site-modules/editorial/components/top-rated/icons/electric-bolt';

export function WinnerCard({ tileEntry, index = 0, isMobile = false, style = null, isElectric = false }) {
  const indexClass = `winner-tile-${index + 1}`;
  return (
    <section
      className={classnames('mb-2 mb-md-0 winner-tile overflow-hidden d-flex flex-column pos-r', indexClass, {
        'is-electric': isElectric,
      })}
      style={{ ...style, minHeight: '410px' }}
    >
      {isElectric && (
        <ElectricBolt
          size={32}
          wrapperClass="pos-a"
          wrapperStyle={{
            top: '40px',
            left: '50%',
            transform: 'translate3d(-50%, -50%, 0)',
          }}
        />
      )}
      <header
        className="w-100 d-flex flex-column justify-content-end text-center pb-0_75 pb-md-2 text-white text-shadow-contrast"
        style={{
          marginTop: '80px',
          zIndex: '1',
        }}
      >
        <a
          href={tileEntry.metadata('tileURL').value()}
          className="category-title fw-bold d-flex align-items-center justify-content-center size-20"
        >
          {tileEntry.metadata('categoryTitle').value()}
        </a>
        <span className="d-block vehicle-title mt-0_5">{tileEntry.metadata('vehicleTitle').value()}</span>
      </header>
      <div
        className="image-container w-100 pos-a top-0 left-0 w-100 h-100"
        style={getImageStyle(tileEntry, isMobile)}
      />
      <div
        className={classnames('hover-arrow px-1 py-0_5 pos-a bottom-0 mb-0_5 text-white', {
          'is-desktop': !isMobile,
        })}
      >
        <i className="icon-arrow-right8" aria-hidden />
      </div>
    </section>
  );
}

WinnerCard.propTypes = {
  tileEntry: CmsEntities.Content.isRequired,
  index: PropTypes.number,
  isMobile: PropTypes.bool,
  style: PropTypes.shape({}),
  isElectric: PropTypes.bool,
};
